import PropTypes from 'prop-types';
import React from 'react'
import RadioGroup from 'react-radio-group'

import DoubleSelect from '../RegistrationParts/DoubleSelectTemplate'


export default class extends React.Component {
    static propTypes = {
		changeData: PropTypes.func.isRequired,
		prevSlide: PropTypes.func.isRequired,
		nextSlide: PropTypes.func.isRequired,
		nowOrGoal: PropTypes.oneOf(['now','goal']).isRequired,
		sessionUser: PropTypes.object.isRequired
	};

    render() {

		let options = [
			{
				slug: '0-50000',
				label: '£0-50k per Annum'
			},
			{
				slug: '50000-100000',
				label: '£50-100k per Annum'
			},
			{
				slug: '100000-250000',
				label: '£100-250k per Annum'
			},
			{
				slug: '250000-500000',
				label: '£250-500k per Annum'
			},
			{
				slug: '500000+',
				label: '£500k+ per Annum'
			},
		];

		let title = this.props.nowOrGoal === 'now' ? 'What is your current turnover?' : 'What\'s your aim for the next three years?';

		let input_name = 'turnover',
			user = this.props.sessionUser,
			default_now = user.hasOwnProperty('custom') && user.custom.hasOwnProperty('turnover_now') ? user.custom.turnover_now : '',
			default_goal = user.hasOwnProperty('custom') && user.custom.hasOwnProperty('turnover_goal') ? user.custom.turnover_goal : '';

		return (

			<DoubleSelect 
						options={options}
						title={title}
						input_name={input_name}
						nowOrGoal={this.props.nowOrGoal}
						default_now={default_now}
						default_goal={default_goal}
						now_field={input_name + '_now'}
						goal_field={input_name + '_goal'}
						changeData={this.props.changeData}
						prevSlide={this.props.prevSlide}
						nextSlide={this.props.nextSlide} />

		)

	}
}



// WEBPACK FOOTER //
// ./src/js/views/Registration/RegistrationSlides/TurnoverSlidePart.jsx